import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "vue-vuecmf-dialog 示例", -1);

var _hoisted_2 = /*#__PURE__*/_createTextVNode("打开对话框");

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, " 内容开始 ", -1);

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_39 = /*#__PURE__*/_createElementVNode("div", null, " 这是一个可以最大化及还原的 对话框", -1);

var _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, " 内容结束", -1);

var _hoisted_41 = /*#__PURE__*/_createTextVNode("关闭");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_vuecmf_dialog = _resolveComponent("vuecmf-dialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_el_button, {
    size: "default",
    type: "primary",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.showDlg = true;
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }), _createVNode(_component_vuecmf_dialog, {
    model_value: _ctx.showDlg,
    title: "标题",
    close_on_click_modal: false,
    onUpdateVisible: _ctx.updateVisible,
    onClose: _ctx.close,
    onToggleScreen: _ctx.toggleScreen
  }, {
    content: _withCtx(function () {
      return [_hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16, _hoisted_17, _hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26, _hoisted_27, _hoisted_28, _hoisted_29, _hoisted_30, _hoisted_31, _hoisted_32, _hoisted_33, _hoisted_34, _hoisted_35, _hoisted_36, _hoisted_37, _hoisted_38, _hoisted_39, _hoisted_40];
    }),
    footer: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.showDlg = false;
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_41];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model_value", "onUpdateVisible", "onClose", "onToggleScreen"])], 64);
}